export const environment = {
  apiBaseUri: 'https://convergent-prd-purview-api.azurewebsites.net/api',
  apimOverrideUri: 'https://api.getconvergent.io/carefindr/apim2',
  apimOverrideUriV2: 'https://api.getconvergent.io/carefindr/apim3',
  apiV2BaseUri: 'https://convergent-prd-carefindr-func.azurewebsites.net/api'
};
